import { render } from "./ProgrammeServiceSelector.vue?vue&type=template&id=2857c16f&scoped=true"
import script from "./ProgrammeServiceSelector.vue?vue&type=script&lang=js"
export * from "./ProgrammeServiceSelector.vue?vue&type=script&lang=js"

import "./ProgrammeServiceSelector.vue?vue&type=style&index=0&id=2857c16f&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2857c16f"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
